import Cont_1_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_1_1.jpeg";
import Cont_1_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_1_2.png";
import Cont_1_3 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_1_3.jpg";
import Cont_1_4 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_1_4.jpg";
import Cont_1_5 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_1_5.jpg";
import Cont_1_6 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_1_6.jpeg";

import Cont_2_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_2_1.png";
import Cont_2_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_2_2.jpg";
import Cont_2_3 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_2_3.png";
import Cont_2_4 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_2_4.png";
import Cont_2_5 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_2_5.jpg";

import Cont_3_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_3_1.jpg";
import Cont_3_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_3_2.jpg";
import Cont_3_3 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_3_3.jpg";
import Cont_3_4 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_3_4.jpg";

import Cont_4_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_4_1.jpg";
import Cont_4_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_4_2.jpeg";

import Cont_5_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_5_1.jpg";
import Cont_5_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_5_2.jpg";

import Cont_6_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_6_1.jpeg";
import Cont_6_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_6_2.jpeg";

import Cont_7_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_7_1.png";
import Cont_7_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_7_2.png";
import Cont_7_3 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_7_3.jpg";
import Cont_7_4 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_7_4.jpg";
import Cont_7_5 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_7_5.jpeg";

import Cont_8_1 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_8_1.png";
import Cont_8_2 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_8_2.jpeg";
import Cont_8_3 from "../../../../common/assets/images/Montronix/Photo/Content/Cont_8_3.jpg";

import { Ipoint2D } from "../../../../common/interfaces";

export const points2: Ipoint2D[] = [
  {
    id: 1,
    top: "44%",
    left: "41%",
    title: "Столкновение шпинделя",
    titletext:[""],
    title_short: "Шпиндель",
    content: [Cont_1_1, Cont_1_2, Cont_1_3, Cont_1_4, Cont_1_5, Cont_1_6],
    text: [
      "Аварийные ситуации связанные с врезанием шпиндельного узла в большинстве случаев связаны с человеческим фактором. Последствиями таких аварий могут являться: нарушение геометрических параметров конуса шпинделя, заклинивание подшипников , поломка вала шпинделя.",
    ],
    damage: [
      [
        {height: 50, width: 30, posX: 34, posY: 30},
      ],
      [{height: 40, width: 35, posX: 22, posY: 40}],
      [{height: 40, width: 35, posX: 30, posY: 26}],

      [{height: 12, width: 13, posX: 64, posY: 13},
        {height: 12, width: 13, posX: 17, posY: 33},
        {height: 8, width: 13, posX: 44, posY: 47},
        {height: 12, width: 13, posX: 28, posY: 54}],
      [],
      [{height: 50, width: 30, posX: 40, posY: 30}],

    ],
  },
  {
    id: 2,
    top: "32.5%",
    left: "47%",
    titletext:[""],
    title: "Вибрационные перегрузки",
    title_short: "Перегрузки",
    content: [Cont_2_1, Cont_2_2, Cont_2_3, Cont_2_4, Cont_2_5],
    damage: [
      [],
      [
        {height: 25, width: 20, posX: 50, posY: 15},
        {height: 25, width: 20, posX: 25, posY: 40}
      ],
      [
        {height: 60, width: 30, posX: 8, posY: 40},
      ],
      [{height: 45, width: 30, posX: 8, posY: 40}],
      [{height: 60, width: 40, posX: 35, posY: 20}],
    ],
    text: [
      "Повышенные вибрационные нагрузки при обработке металлов негативно сказываются на ресурсе оборудования, приводя к ускоренному износу подшипниковых узлов шпинделя и элементов приводной системы станка.",
    ],
  },
  {
    id: 3,
    titletext:[""],
    top: "25%",
    left: "48.5%",
    title: "Столкновение с элементами рабочей зоны",
    title_short: "Рабочая зона",
    content: [Cont_3_1, Cont_3_4, Cont_3_2, Cont_3_3],
    text: [
      "Не верное базирование детали или ее привязки к координатам станка , приводит к столкновению рабочего органа с  оснасткой и элементами рабочей зоны. Такие аварийные ситуации могут спровоцировать повреждение фрезерной головы или револьверной головки.",
    ],
    damage: [
      [
        {height: 20, width: 10, posX: 35, posY: 70}
      ],
      [{height: 20, width: 50, posX: 18, posY: 10}],
      [{height: 70, width: 30, posX: 42, posY: 3}],
      [{height: 20, width: 10, posX: 48, posY: 59}],

    ],
  },
  {
    id: 4,
    top: "39%",
    titletext:[""],
    left: "29.5%",
    title: "Нарушения в технологическом процессе",
    title_short: "Тех. процесс",
    content: [Cont_4_1, Cont_4_2],
    text: [
      "Нарушения технологического процесса или ошибки в режимах обработки негативно сказываются на качестве изготавливаемой детали: дробление на обрабатываемый поверхности, следы от фрезы и т.д . В конечном итоге деталь не проходит ОТК и отбраковывается.",
    ],
    damage: [[{height: 37, width: 45, posX: 30, posY: 27}],
      [{height: 37, width: 65, posX: 16, posY: 31}]],
  },
  {
    id: 5,
    top: "29%",
    titletext:[""],
    left: "58%",
    title: "Ошибки управляющей программы",
    title_short: "Упр. программа",
    content: [Cont_5_1, Cont_5_2],
    text: [
      "Ошибки управляющей программы помимо повышенных вибраций также приводят к непредсказуемому перемещению рабочего органа, что может привести к аварийным ситуациям и выводу  оборудовании  из строя",
    ],
    damage: [
      [],
      [
        {height: 34, width: 33, posX: 30, posY: 45},
      ],
      [],
    ],
  },
  {
    id: 6,
    top: "41%",
    titletext:[""],
    left: "65%",
    title: "Столкновение с магазином инструментов",
    title_short: "Магазин инструментов",
    content: [Cont_6_1, Cont_6_2],
    text: [
      "Технологических процесс изготовления любой детали неразрывно связан с постоянной сменой  инструмента, а ошибки настройки магазина инструмента или  присутствие частей детали на пути следования рабочего органа могут привести к столкновению частей станка и выходу из строя шпинделя или сменщика инструментов.",
    ],
    damage: [
      [
        {height: 32, width: 18, posX: 24, posY: 24},
        {height: 36, width: 22, posX: 48, posY: 45},
      ],
      [{height: 36, width: 22, posX: 35, posY: 38}],
    ],
  },
  {
    id: 7,
    top: "40%",
    left: "43.5%",
    title: "Поломка инструмента",
    titletext:[""],
    title_short: "Поломка инструмента",
    content: [Cont_7_1, Cont_7_2, Cont_7_3, Cont_7_4, Cont_7_5],
    text: [
      "Вследствие ошибок УП, повышенной вибрации, нарушений в технологическом процессе в первую очередь негативно сказываются на режущем инструмента приводя к его разрушению, что приводит к браку деталей и увеличению их себестоимости.",
    ],
    damage: [
      [
        {height: 34, width: 33, posX: 38, posY: 38},
      ],
      [
        {height: 45, width: 33, posX: 26, posY: 24},
      ],
      [
        {height: 45, width: 33, posX: 26, posY: 24},
      ],
      [
        {height: 10, width: 20, posX: 46, posY: 28},
      ],
      [{height: 26, width: 35, posX: 18, posY: 28},],
    ],
  },
  {
    id: 8,
    top: "17.5%",
    titletext:[""],
    left: "60%",
    title: "Скрытые дефекты ШУ и приводных узлов станка",
    title_short: "Скрытые дефекты",
    content: [Cont_8_1, Cont_8_2, Cont_8_3],
    text: [
      "Скрытые дефекты шпиндельного узла или элементов привода осей станка, могут привести к непрогнозируемому выходу из строя всего станка и способствовать длительному простою и срыву производственного плана",
    ],
    damage: [
      [
        {height: 50, width: 48, posX: 30, posY: 22},
      ],
      [{height: 6, width: 15, posX: 36, posY: 34},
        {height: 7, width: 14, posX: 61, posY: 49},],
      [{height: 50, width: 35, posX: 22, posY: 35},],
    ],
  },
];
